import { AddressRecord } from "@/types/address.types";
import { ADIFRecord } from "@/types/adif.types";

export interface CallSignValidationResult {
  valid: boolean;
  error?: string;
}

export function validateCallSign(call: string): CallSignValidationResult {
  const trimmedCall = call.trim();
  
  if (trimmedCall.length < 3) {
    return { valid: false, error: "呼号长度至少为3位" };
  }
  
  if (trimmedCall.length > 15) {
    return { valid: false, error: "呼号长度不能超过15位" };
  }
  
  const callSignPattern = /^[A-Z0-9]+(?:\/[A-Z0-9]+)*$/i;
  if (!callSignPattern.test(trimmedCall)) {
    return { valid: false, error: "呼号只能包含字母、数字和斜杠" };
  }
  
  const parts = trimmedCall.split('/');
  const hasValidPart = parts.some(part => {
    const hasLetter = /[A-Z]/i.test(part);
    const hasDigit = /[0-9]/.test(part);
    
    if (!hasLetter || !hasDigit) {
      return false;
    }
    
    const digitIndex = part.search(/[0-9]/);
    if (digitIndex === -1) {
      return false;
    }
    
    const afterDigit = part.substring(digitIndex + 1);
    const hasLetterAfterDigit = /[A-Z]/i.test(afterDigit);
    
    return hasLetterAfterDigit;
  });
  
  if (!hasValidPart) {
    return { valid: false, error: "呼号格式不正确，必须包含前缀、数字和后缀" };
  }
  
  return { valid: true };
}

export function validateAddressRecord(record: AddressRecord): boolean {
  return (
    typeof record.call === 'string' && record.call.trim().length > 0 &&
    typeof record.address === 'string' && record.address.trim().length > 0
  );
}

export function validateADIFRecord(record: ADIFRecord): boolean {
  const requiredFields = ["call", "qso_date", "time_on", "band", "mode"];
  return requiredFields.every((field) => {
    const value = record[field as keyof ADIFRecord];
    return value !== undefined && value !== null && value !== "";
  });
}

export function validateFileSize(file: File, maxSize: number): boolean {
  return file.size <= maxSize;
}

export function validateFileType(file: File, allowedTypes: string[]): boolean {
  return allowedTypes.includes(file.type);
}
